import type { FaireProductEntity } from "../../entity_types/product";

export const p_8usqwzc23s: FaireProductEntity = {
  token: "p_8usqwzc23s",
  type: "product",
  name: "24K Gold Filled Nature Flower Add-On Charm in Gold & Silver | AC335 AC336",
  brandToken: "b_374b66mxaz",
  brandName: "Aim Eternal",
  imageUrl:
    "https://cdn.faire.com/fastly/09c71397e82c4eaf6dccc26544666fa44919db6cf4e417fe21bbba2a1ea2af16.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3511f742f2dbeb74fb5893cbdc7db5bac405f3044ebe0453014b9a8d4e4ee977.jpeg",
    "https://cdn.faire.com/fastly/183c4c3261fde1904425932e1ad65585d5d5883ee2dc7179b6a28206bcdf5c9f.jpeg",
    "https://cdn.faire.com/fastly/51ed96c6538b14039d7956ccae80b4b3263c4dc764cf595e73ed55f148e0693e.jpeg",
    "https://cdn.faire.com/fastly/7ecf39d75cc9da42ee67cf3bd103fa2f6cf8826a18793d99b425f4f33d125fa1.jpeg",
  ],
  priceDollars: 2.76,
  description:
    "Material: Brass, Gold Filled\nTone: Rhodium Plated\nSize: 10.8mm x 9mm\nTheme: Floral, Flower Chain\n\n",
  tags: [],
  msrpDollars: 5.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:26.998Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
